module.exports = __webpack_public_path__ + "img/template-1-desktop.f1680d66.svg";